import { Avatar } from '@wix/design-system';
import React, { FC, useMemo } from 'react';

import type { Agent } from '../../../../types/domain';

interface AgentAvatarProps {
  readonly agent: Agent;
}

export const AgentAvatar: FC<AgentAvatarProps> = ({ agent }) => {
  const imgProps = useMemo(
    () => ({
      src: agent.profileImage,
    }),
    [agent.profileImage],
  );

  return <Avatar shape="square" size="size24" name={agent.fullName} imgProps={imgProps} />;
};
